import styled from 'styled-components';
import { theme } from '@/styles/theme/index.jsx';

export const StyledComponent = styled.section`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    transition: ${theme.transition};
    background: #5D8D3B;
	opacity: 0;
    .main-menu-mobile__items {
        display: none;
    }

    &.color {
        background: #101825;
        border-bottom: 1px solid rgba(255, 255, 255, 0.4);

        .sub-menu-wrapper {
            top: 70px;

            li {
                &:after {
                    display: none !important;
                }
            }
        }

        .middle_content .middle-menu li a {
            color: #fff;
        }

        .middle-menu {
            li {
                &:after {
                    background: #fff !important;
                }

                a {
                    &:hover {
                        color: #5D8D3B !important;
                    }
                }
            }
        }

        .menu-hamburger {
            svg {
                circle {
                    fill: #fff;
                }
            }
        }

        .text-content {
            p {
                color: #fff;
            }
        }

        .hamburger-btn {
            img {
                &:first-child {
                    display: none;
                }

                &:last-child {
                    display: block !important;
                }
            }
        }
    }

    .sub-menu-wrapper {
        position: fixed;
        left: 0;
        right: 0;
        top: 95px;
        background: white;
        padding: 60px ${props => props.offset + 15}px 40px;
        transition: ${theme.transition};
        //opacity: 0;
        //visibility: hidden;
        overflow-y: scroll;
        max-height: calc(100vh - 120px);
        max-height: calc(var(--vh, 1vh) * 100 - 120px);
        width: calc(100% - ${props => props.offset * 2 + 15}px);
        margin: 0 auto;

        .dc-btn a {
            display: inline-flex !important;
            padding: 0 !important;
        }

        .top {
            padding-bottom: 60px;
            border-bottom: 1px solid #152637;

            &.active {
                a {
                    color: #dd223f;

                    span {
                        color: #dd223f !important;
                    }
                }
            }

            ul {
                display: flex;
                gap: 30px;
                flex-wrap: wrap;

                li {
                    flex: 0 0 calc(33.3333% - 40px);

                    &:after {
                        display: none !important;
                    }

                    a {
                        font-weight: 400;
                        font-size: 1.125rem;
                        line-height: 100%;
                        letter-spacing: 0;
                        color: #152637;
                        display: inline-flex;
                        gap: 15px;
                        transition: ${theme.transition};
                        padding: 0;
                        align-items: center;
                        @media (max-width: 1366px) {
                        }

                        img {
                            width: 40px;
                            height: 40px;
                        }

                        &:after {
                            display: none !important;
                        }

                        span {
                            font-weight: 500;
                            font-size: 1rem; /* 16px */
                            line-height: 1.25rem; /* 20px */
                            letter-spacing: 0; /* 0% = normal */
                            color: #152637;
                            transition: ${theme.transition};
                        }

                        &:hover {
                            span {
                                color: rgba(221, 34, 63, 0.5);
                            }
                        }
                    }
                }
            }
        }

        .bottom {
            padding-top: 40px;

            .d-flex {
                display: flex;
                justify-content: space-between;
                align-items: center;

                h6 {
                    font-weight: 500;
                    font-size: 1rem; /* 16px */
                    line-height: 1.5rem; /* 24px */
                    letter-spacing: 0; /* 0% = normal */
                    color: #152637;

                    i {
                        color: #dd223f;
                    }
                }
            }
        }
    }


    .fix-it {
        position: absolute;
        right: 0;
        bottom: 0;
        object-fit: cover;
        left: 0;
        z-index: -1;
    }

    .middle_content {
        //padding: 25px 0;
        position: relative;
        height: auto;
        align-items: center;
        display: flex;
        .container {
            .row {
                align-items: center;

                .hamburger-btn {
                    position: relative;

                    img {
                        //width: 90px;

                        &:last-child {
                            display: none;
                        }
						
						@media(max-width: 1024px) {
							height: 32px;
						}
                    }

                    .hamburger-lines {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;

                        &:hover {
                            .line1 {
                                width: 0;
                                transition: ${theme.transition};
                            }

                            .line2 {
                                width: 4vw;
                                transform: translateY(-5px);
                                transition: ${theme.transition},
                            }
                        }
                    }
                }

                .button_wrapper {
                    gap: 15px;

                    .wrapper {
                        position: relative;
                        z-index: 99999;
                    }
                }
            }
        }

        .middle-menu {
            display: flex;
            gap: 30px;
            justify-content: end;

            li {
                position: relative;

                &:after {
                    position: absolute;
                    content: '';
                    width: 0;
                    bottom: 0;
                    transition: ${theme.transition};
                    left: 0;
                    height: 2px;
                    right: 0;
                    background: ${theme.colors.hover};
                    opacity: 0;
                }

                &.active {
                    &:after {
                        opacity: 1;
                        width: 100%;
                    }
                }

                a {
                    font-weight: 400;
                    font-size: 1.125rem;
                    line-height: 100%;
                    letter-spacing: 0;
                    color: white;
                    display: inline-block;
                    padding: 38px 0;
                    @media (max-width: 1280px) and (min-width: 1024px) {
                        font-size: 0.85rem;
                    }

                    .sub-menu-wrapper {
                        a {
                            padding: 0;
                        }
                    }

                    &:hover {
                        .sub-menu-wrapper {
                            opacity: 1;
                            visibility: visible;

                            .dc-btn {
                                a {
                                    color: #152637;

                                    &:hover {
                                        color: #dd223f;
                                    }
                                }
                            }

                            a {
                                color: #dd223f;
                            }
                        }
                    }
                }

                &:hover {
                    &:after {
                        opacity: 1;
                        width: 100%;
                    }

                    .sub-menu-wrapper {
                        opacity: 1;
                        visibility: visible;

                        .dc-btn {
                            a {
                                color: #152637;

                                &:hover {
                                    color: #dd223f;
                                }
                            }
                        }

                        a {
                            color: #dd223f;
                        }
                    }
                }
            }
        }

        @media (max-width: 1024px) {
            //padding: 25px 0;
			height: 80px;
            backdrop-filter: blur(20px);
            //background: rgba(0, 0, 0, 0.2);
            z-index: 999;
			
            .col-md-8 {
                display: none;
            }

            .middle-menu {
                display: none;
            }
        }
    }

    .overlay {
        background: transparent;
        opacity: 0;

       
    }

    .overlay-main-bg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgb(0 0 0 / 50%);
        backdrop-filter: blur(10px);
        z-index: 999999;
    }

    .menu-overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        background: #efefef;
        opacity: 0;
        visibility: hidden;
		transform: translateX(100%);
        z-index: 999;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
		height: calc(var(--vh, 1vh) * 100)
        width: 33.333%;

        @media (max-width: 1024px) {
            top: 80px;
            height: calc(100vh - 80px);
            height: calc(var(--vh, 1vh) * 100 - 80px);
            width: 80%;
            background: #5D8D3B;

            a {
                font-weight: 400;
                font-size: 1.125rem;
                line-height: 100%;
                letter-spacing: 0;
                color: white;
            }
        }
    }

    &.scroll-down {
        transform: translate3d(0, -100%, 0);
    }

    &.scroll-up {
        transform: translate3d(0, 0, 0);
    }


    .relative {
        //border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        margin-bottom: 25px;

        .item-wrapper {
            opacity: 0;
            transform: translateY(15px);

            .accordion-item {
                background: transparent;
                border-radius: 0;
                border: none;

                .accordion-header {
                    .accordion-button {
                        background: transparent;
                        border-radius: 0;
                        border: none;
                        padding: 0;
                        font-weight: 400;
                        font-size: 1.125rem;
                        line-height: 100%;
                        letter-spacing: 0;
                        color: white;
                        transition: ${theme.transition};

                        &:after {
                            background-image: url('/images/static/arrowdone.svg');
                        }

                        &[aria-expanded='true'] {
                            border-bottom: 1px solid #fff;
                            padding-bottom: 20px;
                            @media (max-width: 1366px) {
                                padding-bottom: 15px;
                            }
                        }
                    }
                }

                .accordion-body {
                    padding: 20px 0;

                    .item-single {
                        margin-bottom: 10px;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }

                    @media (max-width: 1366px) {
                        padding: 15px 0;
                    }
                }
            }

            .nav-item {
                color: #fff;
                cursor: pointer;
                background: none;
                border: none;
                text-align: left;
                counter-reset: compteListe;
                list-style-type: none;
                position: relative;
                z-index: 1;
                transition: ${theme.transition};

                &:hover {
                    color: ${theme.colors.hover} !important;
                    z-index: 100 !important;
                    transition: ${theme.transition};
                }
            }

            &:hover {
                position: relative;
                z-index: 100;
            }
        }

        @media (max-width: 1366px) {
            padding-bottom: 15px;
            margin-bottom: 15px;
        }
    }

    .bottom-section {
        padding: 0 0 90px;
        position: absolute;
        z-index: 99;
        left: 0;
        right: 0;
        bottom: 0;

        .container {
            height: auto;
            margin: 0 auto;
            position: relative;
            padding-top: 50px;

            &:after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                width: calc(100% - 30px);
                top: 0;
                height: 1px;
                margin: 0 auto;
                background: ${theme.colors.themeColor300};
            }
        }

        .dc-btn-link {
            &:first-child {
                a {
                    text-decoration: underline;
                }
            }

            &:last-child {
                a {
                    font-weight: bold;
                }
            }
        }

        a {
            color: rgba(33, 33, 33, 0.6);
            font-size: 0.9rem;
            font-style: normal;
            font-weight: 400;
            line-height: 21.78px; /* 21.78px */
            letter-spacing: -0.396px;
        }

        .info-section {
            display: flex;
            justify-content: space-around;
        }
    }

    .mobile-menu {
        display: none;
        position: relative;
        margin: 0;
        height: calc(100vh - 125px);
        height: calc(var(--vh, 1vh) * 100 - 125px);
        overflow-y: scroll;

        .dc-btn {
            padding-bottom: 60px;
        }

        .relative {
            .item-wrapper {
                transform: translateY(0);
                opacity: 1;

                a {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
            }
        }
    }

    .sub-menu-sub {
        position: fixed;
        top: 93px;
        padding: 60px 15px;
        background: #5D8D3B;
        left: 0;
        right: 0;
        height: calc(100svh - 60px);
        transition: ${theme.transition};
        transform: translateX(100%);
        opacity: 0;
        visibility: hidden;
        z-index: 333;
        overflow-y: scroll;

        &.active {
            transform: translateX(0);
            opacity: 1;
            visibility: visible;
            width: 100%;
        }

        p {
            color: #fff;
        }

        .content-menu {
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;
            padding: 20px 0;
            margin-bottom: 60px;

            h6 {
                font-weight: 500;
                font-size: 1rem; /* 16px */
                line-height: 1.5rem; /* 24px */
                letter-spacing: 0; /* 0% */
                color: #fff;

                i {
                    color: #fff;
                }
            }

            .dc-btn {
                padding: 0;
            }
        }

        .back-down {
            display: flex;
            align-items: center;
            gap: 25px;
            margin-bottom: 60px;

            p {
                font-weight: 500;
                font-size: 1.5rem; /* 24px */
                line-height: 1.75rem; /* 28px */
                letter-spacing: 0; /* 0% = normal */
            }
        }

        .relative {
            .item-wrapper {
                a {
                    justify-content: unset !important;
                    gap: 15px;
                }
            }
        }
    }

    @media (max-width: 1024px) {
        .col-md-3, .button_wrapper {
            width: 50%;
            flex: 0 0 50%;
        }

        .col-md-9 {
            display: none;
        }

        .top-section {
            padding: 0 15px !important;
            top: 60px;
            display: none;
        }

        .mobile-menu {
            display: block;
            padding: 75px 35px 0 !important;
            top: 0;
			.wrapper-close{
                position: absolute;
                right: 25px;
                top: 5px;
                z-index: 3;
			}
			&:after{
				content: '';
				background-color: rgba(255,255,255,0.25);
				height: 1px;
				width: calc(100% - 50px);
				margin: auto;
				position: absolute;
				left: 0;	
				right: 0;	
				top: 35px;	
			}

            &:before{
                content: '';
                background-color: rgba(255,255,255,1);
                height: 1px;
                width: calc(100% - 50px);
                margin: auto;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
				
				@media(max-width: 360px){
					display: none;
				}
            }
        }
    }
`;